import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: null,
        token: null,
        globalAuthLoading: true // Keeps the App splash screen visible while checking local storage
    },
    reducers: {
        // ADD THIS ACTION INSIDE YOUR REDUCERS BLOCK:
        initializeAuthSession: (state) => {
            const token = localStorage.getItem('access_token');
            const savedUser = localStorage.getItem('user_profile');

            if (token && savedUser) {
                state.token = token;
                state.user = JSON.parse(savedUser);
            }
            
            // Turn off the global loading splash screen
            state.globalAuthLoading = false;
        },
        loginUser: (state, action) => {
            state.token = action.payload.token;
            state.user = action.payload.user;
            localStorage.setItem('access_token', action.payload.token);
            localStorage.setItem('user_profile', JSON.stringify(action.payload.user));
        },
        logout: (state) => {
            state.token = null;
            state.user = null;
            localStorage.removeItem('access_token');
            localStorage.removeItem('user_profile');
        }
    }
});

// MAKE SURE IT IS EXPORTED HERE AT THE BOTTOM:
export const { initializeAuthSession, loginUser, logout } = authSlice.actions;
export default authSlice.reducer;